var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPill = function SvgPill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.742 8.083-1.875-1.875-1.95-1.95c-2.109-2.116-5.55-2.108-7.659 0a5.375 5.375 0 0 0-1.583 3.834 5.41 5.41 0 0 0 1.583 3.833l3.834 3.833a5.393 5.393 0 0 0 3.833 1.584 5.392 5.392 0 0 0 3.833-1.584 5.375 5.375 0 0 0 1.584-3.833 5.41 5.41 0 0 0-1.584-3.833l-.016-.009Zm-11.825 0c0-1.116.433-2.158 1.216-2.95a4.17 4.17 0 0 1 2.95-1.216 4.17 4.17 0 0 1 2.95 1.216l1.634 1.634a12.157 12.157 0 0 1-2.434 3.466 12.258 12.258 0 0 1-3.466 2.434l-1.634-1.634a4.147 4.147 0 0 1-1.216-2.95Zm10.941 6.775a4.17 4.17 0 0 1-5.891 0l-1.259-1.266a13.471 13.471 0 0 0 3.417-2.484A13.686 13.686 0 0 0 13.608 7.7l1.259 1.258a4.147 4.147 0 0 1 1.216 2.95 4.161 4.161 0 0 1-1.216 2.95h-.009Z",
    fill: "current"
  })));
};
export default SvgPill;